import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { NAVBAR_HEIGHT } from 'constants/editor';

import { NavWrapper } from '../NavWrapper/NavWrapper';
import { ToolbarContainer } from '../ToolbarContainer/ToolbarContainer';
import { SIDEBAR_WIDTH, TOOLBAR_HEIGHT } from './Page.config';

const defaultSkeletonProps = { borderRadius: 'base' };

const NavBarLoading = () => (
  <NavWrapper navbarHeight={NAVBAR_HEIGHT}>
    <Flex justifyContent='space-between' w='full'>
      <Box mr={2}>
        <Flex align='center' gap='2'>
          <Skeleton height='20px' width='80px' {...defaultSkeletonProps} />
          <Skeleton height='20px' width='180px' {...defaultSkeletonProps} />
        </Flex>
      </Box>
      <Flex mr={2} gap={2}>
        <Skeleton height='20px' width='32px' {...defaultSkeletonProps} />
        <Skeleton height='20px' width='80px' {...defaultSkeletonProps} />
        <Skeleton height='20px' width='32px' {...defaultSkeletonProps} />
      </Flex>
    </Flex>
  </NavWrapper>
);

const TollbarLoader = () => {
  return (
    <ToolbarContainer
      minH={`${TOOLBAR_HEIGHT}px`}
      overflow='hidden'
      h='fit-content'
      w={`calc(100vw - ${SIDEBAR_WIDTH}px)`}
      pt={2}
      px={4}
      alignItems='flex-start'
      justifyContent='flex-end'
      borderBottom='1px solid'
      borderColor='gray.100'
    >
      <Flex w='fit-content' alignItems='flex-end' py='1px' gap={2}>
        <Skeleton height='32px' width='32px' {...defaultSkeletonProps} />
        <Skeleton height='32px' width='32px' {...defaultSkeletonProps} />
        <Skeleton height='32px' width='32px' {...defaultSkeletonProps} />
      </Flex>
    </ToolbarContainer>
  );
};

const SideBarLoading = () => {
  return (
    <Flex
      width={SIDEBAR_WIDTH + 'px'}
      minWidth={SIDEBAR_WIDTH + 'px'}
      height={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
      overflowY='auto'
      flexDirection='column'
      shadow='4px 0px 4px -4px rgb(0 0 0 / 30%)'
      zIndex='sideBar'
      justifyContent='center'
    >
      <Flex marginTop='auto' marginBottom='auto' alignItems='center' flexDirection='column' gap='24px'>
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
        <Skeleton height='48px' width='48px' {...defaultSkeletonProps} />
      </Flex>
    </Flex>
  );
};

export function PageLoader() {
  return (
    <>
      <NavBarLoading />
      <Flex direction='row'>
        <SideBarLoading />
        <TollbarLoader />
      </Flex>
    </>
  );
}
